import {UserAccessLevel} from 'graphql-client/__generated/graphqlGlobalTypes';

export interface Capability {
  key: string;
  displayName: string;
  isEnabled: boolean;
  accessLevel?: AccessLevelToDisplay;
  edited?: boolean;
}

export interface EntityCapability {
  id: string;
  capability: Capability;
  accessLevel: UserAccessLevel;
}

export interface UserWithCapabilities {
  id: string;
  name: string;
  capabilities: Array<EntityCapability>;
}

// TODO(Steven): Replace with GraphQL generated enum
export enum AccessLevel {
  NO_ACCESS = 'NO_ACCESS',
  READ_ACCESS = 'READ_ACCESS',
  FULL_ACCESS = 'FULL_ACCESS',
}

export const ACCESS_LEVEL_MULTIPLE_VALUES = 'MULTIPLE_VALUES';

export type AccessLevelToDisplay = AccessLevel | typeof ACCESS_LEVEL_MULTIPLE_VALUES;

export const ACCESS_LEVELS_TO_DISPLAY_NAME: {[key in AccessLevelToDisplay]: string} = {
  NO_ACCESS: 'None',
  READ_ACCESS: 'Read',
  FULL_ACCESS: 'Full',
  MULTIPLE_VALUES: 'Multiple Values',
};

export const ACCESS_LEVELS: Array<AccessLevel> = [
  AccessLevel.NO_ACCESS,
  AccessLevel.READ_ACCESS,
  AccessLevel.FULL_ACCESS,
];

// StandardFeatures are features that are shared by multiple capabilities. We expect each capability to have
// their own version of each StandardFeature, e.g. REGISTRY_EDIT, MOLBIO_EDIT, etc.
export enum StandardFeature {
  ADMIN = 'ADMIN',
  DISCOVER = 'DISCOVER',
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  EDIT = 'EDIT',
  EDIT_TAGS = 'EDIT_TAGS',
  MOVE = 'MOVE',
  OPEN = 'OPEN',
  SHOW_DETAILS = 'SHOW_DETAILS',
  AT_MENTION = 'AT_MENTION',
  ARCHIVE = 'ARCHIVE',
  UNARCHIVE = 'UNARCHIVE',
}

export enum AccessChangeAction {
  DIRECT_REMOVAL = 'DIRECT_REMOVAL',
  INDIRECT_REMOVAL = 'INDIRECT_REMOVAL',
  INDIRECT_REDUCTION = 'INDIRECT_REDUCTION',
  INDIRECT_MIXED = 'INDIRECT_MIXED',
}

export enum AccessChangeActionCategory {
  REMOVAL = 'REMOVAL',
  REDUCTION = 'REDUCTION',
}

export interface AccessLevelChange {
  INITIAL: Array<AccessLevel>;
  FINAL: Array<AccessLevel>;
}

export const ACCESS_LEVEL_CHANGES: {[key in AccessChangeActionCategory]: AccessLevelChange} = {
  REMOVAL: {
    INITIAL: [AccessLevel.FULL_ACCESS, AccessLevel.READ_ACCESS],
    FINAL: [AccessLevel.NO_ACCESS],
  },
  REDUCTION: {
    INITIAL: [AccessLevel.FULL_ACCESS],
    FINAL: [AccessLevel.READ_ACCESS],
  },
};
